import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';
import { tabsClasses } from '@mui/material/Tabs';
import _ from 'lodash';
import deepmerge from 'deepmerge';

import ArchivedPromotionCampaignsList from './archived_promotion_campaigns_list';
import ActivePromotionCampaignsList from './active_promotion_campaigns_list';
import PageHeader from '../../../common/page_header';
import { Button } from '../../../common/button';
import { FormRouteEnum } from '../../../../core/enums/common/route';
import { ROUTE_PROMOTION_CAMPAIGNS_FORMS_NEW } from '../../../../core/constants';
import SelectField from '../../../common/select_field';
import { getDefaultPaginationQueryValues } from '../../../../core/utils/api_utils';

const initialQueryParams = {
    ...getDefaultPaginationQueryValues,
    sort: ['workingName', 'asc'],
    showArchived: false,
    filter: 'all'
};

const filterOptions = [
    { value: 'all', label: 'Wszystkie' },
    { value: 'repeatable', label: 'Powtarzalne' },
    { value: 'nonRepeatable', label: 'Jednorazowe' }
];

const PromotionCampaignsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [tab, setTab] = useState(location?.state?.tab || 0);
    const [queryParams, setQueryParams] = useState(location?.state?.queryParams || initialQueryParams);

    const onTabChange = (tabValue) => {
        navigate(location.pathname, {});
        setTab(tabValue);
        setQueryParams(prevState => deepmerge(prevState, {
            showArchived: tabValue === 1,
            filter: filterOptions[0].value,
            page: 0
        }));
    };

    const onSelectFilterChange = (event) => {
        setQueryParams(prevState => deepmerge(prevState, { filter: event.target.value, page: 0 }));
    };

    const renderView = () => {
        if (tab === 0) {
            return <ActivePromotionCampaignsList tab={ tab } queryParams={ queryParams }
                                                 setQueryParams={ setQueryParams }/>;
        }
        if (tab === 1) {
            return <ArchivedPromotionCampaignsList tab={ tab } queryParams={ queryParams }
                                                   setQueryParams={ setQueryParams }/>;
        }

        return null;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>
            <PageHeader
                title="Akcje promocyjne"
                actions={
                    <Button onClick={ () => navigate(ROUTE_PROMOTION_CAMPAIGNS_FORMS_NEW, {
                        state: {
                            action: FormRouteEnum.NEW,
                            tab,
                            queryParams
                        }
                    }) }>
                        Dodaj akcję promocyjną
                    </Button>
                }
            />

            <Box sx={ {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                borderBottom: 1,
                borderColor: 'divider'
            } }>
                <Tabs
                    value={ tab }
                    onChange={ (_, value) => onTabChange(value) }
                    sx={ {
                        [`& .${ tabsClasses.scrollButtons }`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    } }
                >
                    <Tab label="Aktywne"/>
                    <Tab label="Archiwalne"/>
                </Tabs>

                {
                    tab === 0 && (
                        <Box sx={ { width: 250, pb: 1, px: 2 } }>
                            <SelectField
                                label="Pokaż"
                                value={ _.pick(queryParams, ['filter']).filter }
                                onChange={ onSelectFilterChange }
                                options={ filterOptions }
                                size="small"
                            />
                        </Box>
                    )
                }
            </Box>

            { renderView() }
        </Box>
    );
};

export default PromotionCampaignsPage;